module.exports = __webpack_public_path__ + "./assets/office365_logo.png";